import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../store/userSlice";

export default function AdminPage() {
  const user = useSelector(selectUser);

  return (
    <div>
      AdminPage
      <div>welcome {user}</div>
    </div>
  );
}
